import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  IComponentTaxonomy,
  IComponentTaxonomyConfiguration,
} from '../modules/packaging-components/component/types'

interface IState {
  componentTaxonomy: IComponentTaxonomy
  configuration: IComponentTaxonomyConfiguration
  error: string
  loading: boolean
}

const initialState: IState = {
  componentTaxonomy: {
    alias: null,
    code: null,
    created: null,
    id: 0,
    isVerified: false,
    lastPublishedDate: null,
    lastUpdatedName: null,
    madeOfMaterials: [],
    name: '',
    researcherName: null,
    state: 0,
    updated: null,
    userEmail: null,
    userId: null,
    verificationComments: null,
    verifiedByEmail: null,
    verifiedByName: null,
    verifiedOn: null,
  },
  configuration: {
    materialEmissionImpacts: [],
    packagingMaterialCategories: [],
    packagingMaterialFunctionalUnits: [],
    packagingProcessingActivities: [],
  },
  error: '',
  loading: true,
}

const componentTaxonomySlice = createSlice({
  name: 'componentTaxonomy',
  initialState,
  reducers: {
    componentTaxonomyFailure(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.loading = false
    },
    componentTaxonomyRequest(state) {
      state.loading = true
    },
    componentTaxonomySuccess(state, action: PayloadAction<IComponentTaxonomy>) {
      state.componentTaxonomy = action.payload
      state.loading = false
    },
    handlePublishStatus(state, action: PayloadAction<number>) {
      state.componentTaxonomy.state = action.payload
    },
    setConfiguration(state, action: PayloadAction<IComponentTaxonomyConfiguration>) {
      state.configuration = action.payload
    },
    setDefaultComponentTaxonomy: () => initialState,
  },
})

export default componentTaxonomySlice.reducer
export const {
  componentTaxonomyFailure,
  componentTaxonomyRequest,
  componentTaxonomySuccess,
  handlePublishStatus,
  setConfiguration,
  setDefaultComponentTaxonomy,
} = componentTaxonomySlice.actions
